const dropdownStyle = `
  border: 0.2px solid #c4c4c4;
  border-radius: 2px;
  width: 100%;

  .icon {
    border: none;
  }

  .text {
    text-transform: capitalize !important;
    font-family: 'Inter' !important;
    font-weight: 400 !important;
    font-size: 13px;
  }

  .visible.menu.transition {
    max-height: 180px !important;

    > [role='option'] > .text {
      font-weight: 300;
      font-size: 13px;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
    }
  }

  &:hover,
  &:focus {
    border: 0.5px solid #00a0c6;
  }
`;

export default dropdownStyle;
